module.exports = __webpack_public_path__ + "img/yiqi.59328f1f.png";